(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["footer"]) return;
  try {
    
  $(function () {
    $('.js_pagescroll').on('click', (e) => {
      smoothScroll($(e.currentTarget).attr('href'), 500, 90);
      return false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  $(function () {
    let $header = $('#js_header');
    let $nav = $('#js_nav');
    let headerH = $header.height();

    $('#js_navopen').on('click', () => {
      $nav.addClass('is_show');
      return false;
    });

    $('#js_navclose').on('click', () => {
      $nav.removeClass('is_show');
      return false;
    });

    $('.js_navscroll').on('click', (e) => {
      smoothScroll($(e.currentTarget).attr('href'), 50, 90);
      $header.toggleClass('is_show');
      return false;
    });

    function scrollNav($this) {
      let winHeight = window.innerHeight;

      if (window.pageYOffset > winHeight) {
        $this.removeClass('is_show');
      } else {
        $this.addClass('is_show');
      }
    }

    if ($header.hasClass('is_index')) {
      scrollNav($header);
      $(window).on('scroll', () => {
        scrollNav($header);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toppage"]) return;
  try {
    
  function scrollAnime($elms) {
    let winHeight = window.innerHeight;
    let len = $elms.length;
    for (let i = 0; i < len; i++) {
      let $this = $elms.eq(i);

      if ($this.offset().top <= window.pageYOffset + winHeight * 0.7) {
        $this.addClass('is_show');
      }
    }
  }

  function scrollFix($this, $wrap) {
    let winHeight = window.innerHeight;

    if ($wrap.offset().top >= window.pageYOffset + (winHeight / 2 - $this.height() / 2)) {
      $this.addClass('is_fix');
    } else {
      $this.removeClass('is_fix');
    }
  }

  $(function () {
   let $topimg = $('#js_topimg');
    let $topimgWrap = $('#js_topimg_wrap');
    let $bgmov = $('#js_bgmov');
    let $bgmovWrap = $('#js_bgmov_wrap');

    setTimeout(() => {
      $('#js_loading_txt').removeClass('is_show');
      $('#js_loading_smoke').addClass('is_show');
      $('#js_loadingmov')[0].play();

      setTimeout(() => {
        $('#js_loading').addClass('is_hide');
        $topimg.addClass('is_show');
        setTimeout(() => {
          $('#js_hero').addClass('is_show');
          $('#js_bgtxt').addClass('is_show');
          $bgmovWrap.addClass('is_show');
          $bgmov[0].play();
        }, 1500);
      }, 1000);
    }, 1000);

    let $tabbtn = $('.js_tabbtn');
    let $tabmain = $('.js_tabmain');

    $tabbtn.on('click', (e) => {
      let $this = $(e.currentTarget);
      $tabbtn.removeClass('is_show');
      $this.addClass('is_show');
      $tabmain.removeClass('is_show');
      $tabmain.eq($this.index()).addClass('is_show');

      return false;
    });

    scrollFix($topimg, $topimgWrap);

    let $elms = $('.js_scrollelm');
    let len = $elms.length;

    window.onscroll = () => {
      scrollFix($topimg, $topimgWrap);
      scrollAnime($elms);
    };
  });

  } catch(e) { console.error(e); }
})();

})();
